// Centralized logging utility — replace console.* with structured, suppressible calls.
// In production, these can be wired to an external service or silenced entirely.

const isDev = process.env.NODE_ENV === "development";

const logging = {
  error(msg, ...args) {
    if (isDev) console.error(`[Guard] ${msg}`, ...args); // eslint-disable-line no-console
  },
  warn(msg, ...args) {
    if (isDev) console.warn(`[Guard] ${msg}`, ...args); // eslint-disable-line no-console
  },
  info(msg, ...args) {
    if (isDev) console.info(`[Guard] ${msg}`, ...args); // eslint-disable-line no-console
  },
};

export default logging;
